import { Component, OnInit } from '@angular/core';
import { WalletSummaryResponse } from '../../shared/services/responses/platform/wallet-summary.response';
import { WalletWithdrawalListResponse } from '../../shared/services/responses/platform/wallet-withdrawal-list.response';
import { WalletSalesListResponse } from '../../shared/services/responses/platform/wallet-sales-list.response';
import { WalletService } from '../../shared/services/apis/platform/wallet.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { LoginValidationComponent } from '../../book-create/login-validation.component/login-validation.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { MenuComponent } from '../../shared/components/menu/menu.component';
import { WithdrawalRequestModalComponent } from './withdrawal-request-modal/withdrawal-request-modal.component';
import { ReturnStruct } from '../../shared/services/structs/return.struct';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatOption,
    MatSelect,
    MatDividerModule,
    MatMenuModule,
    MenuComponent,
    MatExpansionModule,
    FooterComponent,
    LoginValidationComponent,
  ],
})
export class WalletComponent implements OnInit {
  summary?: WalletSummaryResponse;
  inTransit?: WalletWithdrawalListResponse;
  history?: WalletWithdrawalListResponse;
  sales?: WalletSalesListResponse;

  loading = false;
  errMsg = '';

  expanded = new Set<number>();

  constructor(
    private walletSvc: WalletService,
    private dialog: MatDialog
  ) {}

  toggleSale(id: number): void {
    if (this.expanded.has(id)) this.expanded.delete(id);
    else this.expanded.add(id);
  }

  isExpanded(id: number): boolean {
    return this.expanded.has(id);
  }

  ngOnInit(): void {
    this.fetchAll();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private fetchAll(): void {
    this.loading = true;
    this.errMsg = '';

    this.walletSvc.getSummary().subscribe({
      next: res => {
        this.summary = res;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.errMsg = 'Falha ao carregar resumo da carteira.';
      },
    });

    this.walletSvc.getWithdrawalsInTransit().subscribe({
      next: res => (this.inTransit = res),
      error: () => {},
    });

    this.walletSvc.getWithdrawalsHistory(50).subscribe({
      next: res => (this.history = res),
      error: () => {},
    });

    this.walletSvc.getSalesHistory(50).subscribe({
      next: res => (this.sales = res),
      error: () => {},
    });
  }

  formatBRL(v?: number): string {
    const n = typeof v === 'number' ? v : 0;
    return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  formatDate(d?: string | Date): string {
    if (!d) return '-';
    const dt = typeof d === 'string' ? new Date(d) : d;
    return dt.toLocaleDateString('pt-BR');
  }

  canRequestPix(): boolean {
    if (!this.summary) return false;
    return this.summary.availableForWithdrawal >= this.summary.minWithdrawalAmount;
  }

  onRequestPix(): void {
    const ref = this.dialog.open(WithdrawalRequestModalComponent, {
      width: '520px',
      data: {
        availableForWithdrawal: this.summary?.availableForWithdrawal || 0,
        minWithdrawalAmount: this.summary?.minWithdrawalAmount || 0,
        defaultPix: '', // opcional
      },
    });

    ref.afterClosed().subscribe((ok: ReturnStruct) => {
      if (ok.isError) return; // erro tratado no modal
      // recarregar cards/listas
      this.fetchAll?.();
    });
  }
}
